<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-treeview
        v-if="layersGroups.length > 0"
        :items="layersGroups"
        item-key="id"
        :item-text="`name_${$i18n.locale}`"
        open-on-click
        selected-color="primary"
      >
        <template #append="element">
          <v-row no-gutters>
            <!-- layer settings buttons -->
            <v-col v-if="element.item && element.item.layer_type">
              <v-btn icon :title="$i18n.t('settings.editWmsLayer')" @click="action('editWmsLayer', element.item)">
                <v-icon color="grey lighten-1">mdi-settings-outline</v-icon>
              </v-btn>
              <v-btn icon :title="$i18n.t('settings.deleteWmsLayer')" @click="action('deleteWmsLayer', element.item)">
                <v-icon color="grey lighten-1">mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <!-- group settings buttons -->
            <v-col v-else>
              <v-btn icon :title="$i18n.t('settings.editWmsGroup')" @click.stop="action('editWmsGroup', element.item)">
                <v-icon color="grey lighten-1">mdi-settings-outline</v-icon>
              </v-btn>
              <v-btn
                icon
                :title="$i18n.t('settings.deleteWmsGroup')"
                @click.stop="action('deleteWmsGroup', element.item)"
              >
                <v-icon color="grey lighten-1">mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template #label="element">
          <span :class="{ 'font-weight-bold': !element.item.layer_type }">
            {{ element.item[`name_${$i18n.locale}`] }}
          </span>
        </template>
      </v-treeview>
      <span v-else class="pl-4">{{ $i18n.t('default.noLayers') }}</span>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    layersGroups: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    action(name, item) {
      this.$emit(name, item);
    }
  }
};
</script>